import { render, staticRenderFns } from "./CompanySize.vue?vue&type=template&id=08caeab8&"
import script from "./CompanySize.vue?vue&type=script&lang=js&"
export * from "./CompanySize.vue?vue&type=script&lang=js&"
import style0 from "./CompanySize.vue?vue&type=style&index=0&id=08caeab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports